import { connect } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';

interface SelectionDriveItemListPageProps extends AbstractDriveItemListPageProps {
	selection: number[];
}

export class SelectionDriveItemListPage extends AbstractDriveItemListPage<SelectionDriveItemListPageProps> {
	headerLabel = 'messages.my_selection';
	noItemsLabel = 'messages.no_selection';
	hasShareButton = true;
	hasDownloadButton = true;
	hasBottomBar = true;

	initializeView(props: SelectionDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		return this.props.selection;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { selection } = state;
	return { selection };
};

export default connect(mapStateToProps)(SelectionDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Selection.tsx